(ns history.core
  (:import
   [goog.history.Html5History TokenTransformer]
   [goog.history Html5History EventType]
   [goog History])
  (:require
   [very.re-frame.core :as rf]
   [oops.core :refer [oset!]]
   [util.core :refer [get-path-with-query]]
   [goog.events]))

(defn- set-retrieve-token! [t]
  (set! (.. t -retrieveToken)
        (fn [path-prefix location]
          (get-path-with-query location)))
  t)

(defn- set-create-url! [t]
  (set! (.. t -createUrl)
        (fn [token path-prefix location]
          (str path-prefix token)))
  t)

(defn- make-token-transformer []
  (-> (TokenTransformer.) set-retrieve-token! set-create-url!))

(defn make-history []
  (doto (Html5History. js/window (make-token-transformer))
    (.setPathPrefix "")
    (.setUseFragment false)))

(defn handle-url-change [e]
  ;; we are checking if this event is due to user action,
  ;; such as click a link, a back button, etc.
  ;; as opposed to programmatically setting the URL with the API
  (when (.-isNavigation e)
    ;; forward/back button or some browser API has set our token
    (rf/>evt [:router/html-navigation (get-path-with-query)])))

(defonce history (atom nil))

(defn init []
  (reset! history
          (doto (make-history)
            (goog.events/listen EventType.NAVIGATE
                                ;; wrap in a fn to allow live reloading
                                #(handle-url-change %))
            (.setEnabled true))))

(defn kill []
  (doto @history
    (.removeAllListeners)
    (.setEnabled false)
    (.dispose)))

(defn nav! [token]
  (when-not @history (init))
  (.setToken @history token))
